import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { useTranslation } from 'app/lang';
import Footer from 'app/modules/Layout/Footer';
import $context from 'app/modules/MatchResult/$match-result-context';
import ErrorBoundary from 'app/widgets/ErrorBoundary';

import MatchResultDeferred from './components/MatchResultDeferred';

import dictionary from './MatchResult.dictionary.json';

const MatchResultModule = () => {
  const { t } = useTranslation();
  const {
    navigation: {
      selectors: {
        currentLocation,
      },
    },
  } = $context;

  const history = useHistory();
  const { matchId } = useSelector(currentLocation);

  if (!matchId) {
    history.push('/404');
    return null;
  }

  return (
    <>
      <Helmet>
        <meta
          name="description"
          content={t(dictionary.title)} />

        <title>{t(dictionary.description)}</title>
      </Helmet>

      <ErrorBoundary>
        <MatchResultDeferred matchId={matchId} />
        <Footer />
      </ErrorBoundary>
    </>
  );
};

export default MatchResultModule;
